export const environment = {
  // apiBaseURL: "https://syncedapi.azurewebsites.net/",
  apiBaseURL: "/api/",
  production: true,
  isOutlookEnv: false,
  isChromeEnv: false,
  envName: 'staging',
  // The admin portal, now its own app (Synced Admin, repo synced-admin): staging (the default build).
  // A custom domain will replace the Azure host name.
  adminAppUrl: 'https://synced-admin-staging-d4b7d8bsf5grdsbh.eastus-01.azurewebsites.net',
};
